export default function* insightPage() {

}
